<template>
	<v-select
		v-bind="selectProps"
		:class="[
			isActive && 'v-select--active-menu',
		]"
		readonly
		class="ao-great-select-activator"
		@click:clear="$emit('click:clear')"
	>
		<template #chip="{ item }">
			<AoChip
				v-if="multiselect && chips"
				:item="item.raw"
				:itemTitle="itemTitle"
				size="small"
				:closable="multiselect ? closableChips : false"
				@click:close="$emit('click:chipClose', item.raw)"
			/>
			<template
				v-else
			>
				{{ item.title }}
			</template>
		</template>
	</v-select>
</template>

<script setup>
import { computed } from 'vue'

import AoChip from '../AoChip.vue'

// Этот компонент максимально "глупый". Он принимает все пропсы,
// необходимые для v-select, и просто отображает их.
const props = defineProps({
	// Данные
	modelValue: {
		type: [Array, Number, String],
		default: null,
	},

	items: {
		type: Array,
		default: () => [],
	},

	itemTitle: {
		type: String,
		default: 'title',
	},

	itemValue: {
		type: String,
		default: 'value',
	},

	multiselect: {
		type: Boolean,
		default: false,
	},

	// Состояние
	isActive: {
		type: Boolean,
		default: false,
	},
	loading: {
		type: [Boolean, String],
	},
	disabled: {
		type: Boolean,
		default: false,
	},
	clearable: {
		type: Boolean,
		default: false,
	},

	closableChips: { type: Boolean, default: false },

	// UI
	label: String,
	variant: String,
	color: String,
	density: String,
	chips: Boolean,
	prependIcon: String,
	hint: String,
	hideDetails: [Boolean, String],

	// Валидация
	error: Boolean,
})

defineEmits({
	'click:clear': null,
	'click:chipClose': null,
})

// Мы собираем все пропсы в один объект, чтобы передать их в v-select.
// Это делает шаблон чистым, а компонент — легко расширяемым.
const selectProps = computed(() => ({
	modelValue: props.modelValue,
	items: props.items,
  itemTitle: props.itemTitle,
  itemValue: props.itemValue,
  multiselect: props.multiselect,
	label: props.label,
	variant: props.variant,
	color: props.color || 'primary',
	density: props.density,
	loading: props.loading,
	disabled: props.disabled,
	clearable: props.clearable,
	hint: props.hint,
	hideDetails: props.hideDetails ?? 'auto',
	error: props.error,
	chips: props.multiselect ? props.chips : false,
	prependIcon: props.prependIcon,
	height: 24,
	menuIcon: 'mdi-chevron-down',
}))
</script>

<style lang="scss">
.ao-great-select-activator {

	.v-field__input {
		font-size: 14px;
	}

}
</style>
